import fileDownload from "js-file-download";

import ApiDefault from "../../ApiDefault";

export default function ApiDocuments() {
    const apiDefault = ApiDefault("v2/fiscal/documents");

    const managerServiceDetails = async (id) => {
        return await apiDefault.api
            .get(`/${apiDefault.url}/manager-service-out/details/${id}`)
            .then((response) => {
                return {
                    status: response.status === 200,
                    data: response.data.data,
                    info: response.data.info,
                };
            })
            .catch((error) => {
                return {
                    status: false,
                    message: error.response.data.message,
                };
            });
    };

    // Query
    const managerServiceList = async ({ page = 1, pageSize = 5, condition }) => {
        let urlCustom = `/${apiDefault.url}/manager-service-out/list?page=${page}&limit=${pageSize}`;

        for (let field in condition) {
            if (condition[field] !== "") {
                urlCustom += `&${field}=${condition[field]}`;
            }
        }

        return await apiDefault.api
            .get(urlCustom)
            .then((response) => {
                return {
                    status: response.status === 200,
                    data: response.data.data,
                    info: response.data.info,
                };
            })
            .catch((error) => {
                return {
                    status: false,
                    message: error.response.data.message,
                };
            });
    };

    const receiptService = async (files, layout, documentTypeDefault) => {
        return await apiDefault.api
            .post(`/${apiDefault.url}/receipt-service-out/${layout}/${documentTypeDefault}`, files, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                return {
                    status: response.status === 200,
                    data: response.data.data,
                    info: response.data.info,
                    message: response.data.message || [],
                };
            })
            .catch((error) => {
                return {
                    status: false,
                    message: error.response.data.message,
                };
            });
    };

    const defineItemsAndTaxes = async (condition) => {
        return await apiDefault.api
            .post(`/${apiDefault.url}/receipt-service-out/define-items-taxes`, condition)
            .then((response) => {
                return {
                    status: response.status === 200,
                    data: response.data.data,
                    info: response.data.info,
                    message: response.data.message || [],
                };
            })
            .catch((error) => {
                return {
                    status: false,
                    message: error.response.data.message,
                };
            });
    };

    const exportDocuments = async (condition, layout, fileName) => {
        let urlCustom = `/${apiDefault.url}/manager-service-out/export-file/${layout}`;
        const urlConditions = [];

        for (let field in condition) {
            if (condition[field] !== "") {
                urlConditions.push(`${field}=${condition[field]}`);
            }
        }

        if (urlConditions.length) {
            urlCustom += `?${urlConditions.join("&")}`;
        }

        return await apiDefault.api
            .get(urlCustom)
            .then((response) => {
                fileDownload(response.data, fileName + ".txt");
                return {
                    status: response.status === 200,
                };
            })
            .catch((error) => {
                return {
                    status: false,
                    message: error.response?.data?.message || error.message,
                };
            });
    };

    return {
        apiDefault,
        managerServiceList,
        managerServiceDetails,
        receiptService,
        defineItemsAndTaxes,
        exportDocuments,
    };
}
